define(["underscore","@bingads-webui/listener"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__5__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 19);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(20);


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "InMemoryListener", {
  enumerable: true,
  get: function get() {
    return _inMemoryListener.InMemoryListener;
  }
});
Object.defineProperty(exports, "InMemorySink", {
  enumerable: true,
  get: function get() {
    return _inMemorySink.InMemorySink;
  }
});
Object.defineProperty(exports, "SessionStorageSink", {
  enumerable: true,
  get: function get() {
    return _sessionStorageSink.SessionStorageSink;
  }
});

var _inMemoryListener = __webpack_require__(21);

var _inMemorySink = __webpack_require__(22);

var _sessionStorageSink = __webpack_require__(23);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InMemoryListener = void 0;

var _listener = __webpack_require__(5);

var _underscore = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * In memory listener class. This logs to an in-memory object that is passed
 * in. It expects a sink object with write method on it.
 */
class InMemoryListener extends _listener.Listener {
  /**
   * Creates an instance of InMemoryListener.
   * @param {any} [options={}] - The options for in-memory listener
   * @param {Object} options.sink - Sink to push logs to.
   * Should have write method on it
   * @param {Object} options.formatters - Object where values are formatters
   * to use for the listener
   * @param {Object} options.filters - Object where values are filters to
   * use for the listener
   */
  constructor(options = {}) {
    super(options);
    this.formatters = options.formatters || {};
    this.filters = options.filters || {};
    this.sink = options.sink;
  }
  /**
  * Init in memory listener if needed options passed in
  * @returns {undefined} - no returns
  */


  init() {
    if (this.sink && _underscore.default.isFunction(this.sink.write)) {
      this.initialized = true;
    }
  }
  /**
   * writes logs to the listener
   * @param {object} logMessage - logs to be written
   * @returns {undefined} - no returns
  */


  write(logMessage) {
    if (!this.initialized || this.filterLogs(logMessage)) {
      return;
    }

    const formattedMsg = this.formatLogs(logMessage);
    this.sink.write(formattedMsg);
  }

}

exports.InMemoryListener = InMemoryListener;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InMemorySink = void 0;

/**
 * Sink that is compatible with InMemoryListener.
 * Can be passed in to the listener to receive logs.
 */
class InMemorySink {
  /**
   * Creates an instance of InMemorySink.
   * @param {Number} [maxSize=2000] - Maximum size of logs array.
   * Pass in -1 to have unbounded array.
   */
  constructor({
    maxSize = 2000
  } = {}) {
    this.logs = [];
    this.maxSize = maxSize;
  }
  /**
   * Write log to the sink
   * @param {Object} log - Log object to write
   * @returns {undefined} - no returns
   */


  write(log) {
    this.logs.push(log);

    while (this.maxSize > -1 && this.logs.length > this.maxSize) {
      this.logs.shift();
    }
  }
  /**
   * Getter for logs written to sink. Returns the
   * logs array.
   * @readonly
  */


  get items() {
    return this.logs;
  }

}

exports.InMemorySink = InMemorySink;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionStorageSink = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Sink that is compatible with SessionStorage.
 * Can be passed in to the listener to receive logs.
 */
class SessionStorageSink {
  /**
   * Creates an instance of SessionStorageSink.
   * @param {Object} options - Options to initialize
   * @param {Number} [options.maxSize=2000] - Maximum size of logs array.
   * @param {String} options.storageKey - Key to use in session storage
   * Pass in -1 to have unbounded array.
   */
  constructor(options = {}) {
    this.logs = [];
    this.maxSize = options.maxSize || 2000;

    if (!options.storageKey) {
      throw new Error('Cannot create sink without storageKey');
    }

    if (SessionStorageSink.keyCache[options.storageKey]) {
      throw new Error('Storage key is already initialized on page');
    }

    SessionStorageSink.keyCache[options.storageKey] = true;
    this.storageKey = options.storageKey;
    const existingItemsStr = window.sessionStorage.getItem(this.storageKey);
    const existingItems = _underscore.default.isEmpty(existingItemsStr) ? [] : JSON.parse(existingItemsStr);
    existingItems.forEach(formattedMsg => this.write(formattedMsg));
    window.addEventListener('beforeunload', () => {
      this.setItemsOnUnload();
    });
  }
  /**
   * Write log to the sink
   * @param {Object} log - Log object to write
   * @returns {undefined} - no returns
   */


  write(log) {
    this.logs.push(log);

    while (this.maxSize > -1 && this.logs.length > this.maxSize) {
      this.logs.shift();
    }
  }
  /**
   * Getter for logs written to sink. Returns the
   * logs array.
   * @readonly
  */


  get items() {
    return this.logs;
  }

  setItemsOnUnload() {
    window.sessionStorage.setItem(this.storageKey, JSON.stringify(this.logs));
  }

}

exports.SessionStorageSink = SessionStorageSink;

_defineProperty(SessionStorageSink, "keyCache", {});

/***/ })
/******/ ])});;
